import { render, staticRenderFns } from "./zhuhaiInventory.vue?vue&type=template&id=667dd232&scoped=true"
import script from "./zhuhaiInventory.vue?vue&type=script&lang=js"
export * from "./zhuhaiInventory.vue?vue&type=script&lang=js"
import style0 from "./zhuhaiInventory.vue?vue&type=style&index=0&id=667dd232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667dd232",
  null
  
)

export default component.exports